import HighlightTab from './HighlightTab';

export default HighlightTab;
